import React, { useEffect, useRef, useState, useMemo } from "react";
import InputField from '../InputField'
import DropDown from '../DropDown'
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ButtonAdminpanel from "../ButtonAdminpanel";
import ImgUpload from "@/assets/images/webp/image-upload.webp";
import { default as ReactSelect } from "react-select";

import {
  ClassicEditor,
  Essentials,
  Bold,
  Italic,
  Underline,
  FontSize,
  Paragraph,
  List,
} from "ckeditor5";
import RadioButtonField from "../RadioButtonField";
import CheckBox from "../../components/CheckBox";
import SubHeader from "../SubHeader";
import { countryList } from "@/actions/countryAction";
import { connect } from "react-redux";
import { filter, forEach, includes, isEmpty, map, size } from "lodash";
import { getHSCodeList, getHSCodeSearchList, getQuantityUnitList, getCategories, getPortsByCountry } from "@/actions/defaultDataAction";
import { createProduct } from "@/actions/productAction";
import { getPrefix, showSuccessMessage } from "@/utils/common";
import { useNavigate } from "react-router-dom";
import { privateRoutePaths } from "@/routes/private.route.config";
import { ToastContainer } from "react-toastify";
import { useAuth } from "@/AuthProvider";
import roles from "@/constant/roles.config";
import errorMessages from "@/constant/errorMessages";
import { getCompanyListByTradeMode } from "@/actions/memberAction";
import { productList } from "@/actions/productAction";



function Index(props) {

  const shippingTerms = ["EXW", "FOB", "FAS", "DPU", "DDP"];
  const ALLOWED_TYPES = ["application/pdf", "image/jpeg", "image/png", "image/jpg"];
  const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2 MB

  const mainImgRef = useRef(null);
  const fileInputRef1 = useRef(null);
  const fileInputRef2 = useRef(null);
  const fileInputRef3 = useRef(null);
  const allHsCodesRef = useRef([]);

  const nav = useNavigate();

  const {
    user,
    isPreKYCUser,
    isDemoUser,
    isEndUser,
    isViewer,
    isSuperAdmin,
    isOpUser,
    memberCompanyID,
  } = useAuth();

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [hscodeList, setHsCodeList] = useState([]);
  // const [categoryList, setCategoryList] = useState([]);
  const [memberList, setMemberList] = useState([]);

  const [formData, setFormData] = useState({
    member_id: user && (isPreKYCUser || isEndUser) ? memberCompanyID : null,
    product_name: "",
    category: null,
    product_hs_code: null,
    product_origin_country: null,
    trading_area: [],
    shiiping_terms: [],
    price_type: "fixed",
    price: "",
    price_unit: "",
    minimum_order: "",
    product_desc: "",
    shipping_info: [{ country: "", ports: [], portList: [] }],
    medias: {
      main: { name: "", path: "", file: null },
      other_photos: {},
    },
    product_status: 0
  });

    const [offset, setOffset] = useState(0);
    const [limit, setLimit] = useState(1);
    const [products, setProducts] = useState([]);
    const [selectIndustry,setSelectIndustry] = useState("");
    const [selectOtherIndustry,setSelectOtherIndustry] = useState("");
    const [rawCategories, setRawCategories] = useState([]);

  // const getPrefix = () => {
  //   if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
  //   if (user && isDemoUser) return roles.DEMO.prefix;
  //   if (user && isEndUser) return roles.END_USER.prefix;
  //   if (user && isViewer) return roles.VIEWER.prefix;
  //   return roles.SUPER_ADMIN.prefix;
  // };

  const customFilter = (option, searchTxt) =>
    option.data.label.toLowerCase().includes(searchTxt.toLowerCase());

  const customMemberFilter = (option, searchTxt) =>
    option.data.email.toLowerCase().includes(searchTxt.toLowerCase()) ||
    option.data.label.toLowerCase().includes(searchTxt.toLowerCase());


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (val, fieldName) => {
    const keyMap = {
      category: "category",
      hs_code: "product_hs_code",
      origin_country: "product_origin_country",
      price_unit: "price_unit",
      member_id: "member_id",
    };
    const key = keyMap[fieldName];
    if (key) {
      setFormData((prev) => ({ ...prev, [key]: val }));
    }
  };

  const handlehscodeInputChange = (val = "") => {
    if (!isEmpty(val) && size(val) > 3) {
      fetchHscode(val);
    } else {
      setHsCodeList(allHsCodesRef.current);
    }
  };

  const handleMemberInputChange = (val = "") => {
    fetchMembers(val.length >= 3 ? val : "");
  };

  const handleCheckChange = (e, val) => {
    const { checked } = e.target;

    if (val === "domestic" || val === "international") {
      setFormData((prev) => ({
        ...prev,
        trading_area: checked
          ? [...prev.trading_area, val]
          : filter(prev.trading_area, (v) => v !== val),
      }));
    } else if (includes(shippingTerms, val)) {
      setFormData((prev) => ({
        ...prev,
        shiiping_terms: checked
          ? [...prev.shiiping_terms, val]
          : filter(prev.shiiping_terms, (v) => v !== val),
      }));
    }
  };

  const handlePriceTypeChange = (e) => {
    setFormData((prev) => ({ ...prev, price_type: e.target.value, price: "" }));
    setErrors((prev) => ({ ...prev, price: "", price_unit: "" }));
  };

  const handlePortChange = (newValue, indx) => {
    setFormData((prev) => {
      const sInfo = [...prev.shipping_info];
      sInfo[indx] = { ...sInfo[indx], ports: newValue };
      return { ...prev, shipping_info: sInfo };
    });
  };

  const handleCountryChange = async (val, indx) => {
    if (!val) {
      setFormData((prev) => {
        const sInfo = [...prev.shipping_info];
        sInfo[indx] = { ...sInfo[indx], country: null, ports: null, portList: [] };
        return { ...prev, shipping_info: sInfo };
      });
      return;
    }

    setFormData((prev) => {
      const sInfo = [...prev.shipping_info];
      sInfo[indx] = { ...sInfo[indx], country: val, ports: null, portList: [] };
      return { ...prev, shipping_info: sInfo };
    });

    try {
      const response = await props.getPortsByCountry(val.value);
      const portOptions = map(response, (p) => ({ label: p.name, value: p.id }));
      setFormData((prev) => {
        const sInfo = [...prev.shipping_info];
        sInfo[indx] = { ...sInfo[indx], portList: portOptions };
        return { ...prev, shipping_info: sInfo };
      });
    } catch (err) {
      console.error("getPortsByCountry error:", err);
    }
  };

  const handleImgClick = (e, val) => {
    const refMap = {
      main: mainImgRef,
      img1: fileInputRef1,
      img2: fileInputRef2,
      img3: fileInputRef3,
    };
    refMap[val]?.current?.click();
  };

  const handleAddClick = () => {
    setFormData((prev) => ({
      ...prev,
      shipping_info: [
        ...prev.shipping_info,
        { country: "", ports: [], portList: [] },
      ],
    }));
  };

  const handleRemoveClick = (e, indx) => {
    setFormData((prev) => {
      let sInfo = [...prev.shipping_info];
      sInfo.splice(indx, 1);
      if (isEmpty(sInfo)) {
        sInfo = [{ country: "", ports: [], portList: [] }];
      }
      return { ...prev, shipping_info: sInfo };
    });
  };


  const handleFileChange = (e, fname) => {
    const file = e.target.files[0];
    e.target.value = null;
    if (!file) return;

    const errKey = fname === "main" ? "main_image" : fname;
    let error = "";

    if (!ALLOWED_TYPES.includes(file.type)) {
      error = "The file must be a file of type jpg, png, jpeg or pdf";
    } else if (file.size > MAX_FILE_SIZE) {
      error = "The file must be less than or equal to 2 MB";
    }

    setErrors((prev) => ({ ...prev, [errKey]: error }));

    if (error) {
      removeImage(null, fname);
      return;
    }

    const fileData = { name: file.name, path: URL.createObjectURL(file), file };

    if (fname === "main") {
      setFormData((prev) => ({
        ...prev,
        medias: { ...prev.medias, main: fileData },
      }));
    } else {
      setFormData((prev) => {
        const otherPhotos = { ...prev.medias.other_photos, [fname]: fileData };
        return { ...prev, medias: { ...prev.medias, other_photos: otherPhotos } };
      });
    }
  };

  const removeImage = (e, fname) => {
    const empty = { name: "", path: "", file: null };

    if (fname === "main") {
      if (mainImgRef.current) mainImgRef.current.value = null;
      setFormData((prev) => ({
        ...prev,
        medias: { ...prev.medias, main: empty },
      }));
    } else {
      const refMap = { img1: fileInputRef1, img2: fileInputRef2, img3: fileInputRef3 };
      if (refMap[fname]?.current) refMap[fname].current.value = null;
      setFormData((prev) => {
        const otherPhotos = { ...prev.medias.other_photos, [fname]: empty };
        return { ...prev, medias: { ...prev.medias, other_photos: otherPhotos } };
      });
    }
  };


  const handleFocusOut = (e) => {
    const { name, value } = e.target;
    const productNameRegex = /^[A-Za-z0-9\s\-\/.,&()'+:]{2,150}$/;

    setErrors((prev) => {
      const errObj = { ...prev };

      if (name === "product_name") {
        if (!value) {
          errObj.product_name = errorMessages.FIELD_REQUIRED;
        } else if (size(value) > 150) {
          errObj.product_name = errorMessages.MAX_LENGTH_150_EXCEEDED;
        } else if (!productNameRegex.test(value)) {
          errObj.product_name = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          errObj.product_name = "";
        }
      }

      if (name === "price") {
        if (!value) {
          errObj.price = errorMessages.FIELD_REQUIRED;
        } else if (size(value) > 5) {
          errObj.price = "The field must not be greater than 5 characters.";
        } else if (!/^\d+(\.\d+)?$/.test(value)) {
          errObj.price = errorMessages.IN_VALID_FIELD_FORMAT;
        } else if (Number(value) <= 0) {
          errObj.price = "Price Amount must be greater than zero";
        } else {
          errObj.price = "";
        }
      }

      if (name === "minimum_order") {
        if (value) {
          if (size(value) > 15) {
            errObj.minimum_order = "The field must not be greater than 15 characters.";
          } else if (!/^\d+(\.\d+)?$/.test(value)) {
            errObj.minimum_order = errorMessages.IN_VALID_FIELD_FORMAT;
          } else if (Number(value) <= 0) {
            errObj.minimum_order = "Minimum Order must be greater than zero";
          } else {
            errObj.minimum_order = "";
          }
        } else {
          errObj.minimum_order = "";
        }
      }

      return errObj;
    });
  };

  const validateForm = () => {
    const errObj = { ...errors };

    if (isSuperAdmin || isViewer || isOpUser) {
      errObj.member_id =
        !formData.member_id ? errorMessages.FIELD_REQUIRED : "";
    }

    if (!formData.product_name) {
      errObj.product_name = errorMessages.FIELD_REQUIRED;
    } else if (size(formData.product_name) > 150) {
      errObj.product_name = errorMessages.MAX_LENGTH_150_EXCEEDED;
    } else {
      errObj.product_name = "";
    }

    errObj.category =
      !formData.category ? errorMessages.FIELD_REQUIRED : "";

    errObj.hs_code =
      !formData.product_hs_code ? errorMessages.FIELD_REQUIRED : "";

    errObj.product_origin_country =
      !formData.product_origin_country ? errorMessages.FIELD_REQUIRED : "";

    if (formData.price_type === "fixed") {
      if (!formData.price) {
        errObj.price = errorMessages.FIELD_REQUIRED;
      } else if (!/^\d+(\.\d+)?$/.test(formData.price)) {
        errObj.price = errorMessages.IN_VALID_FIELD_FORMAT;
      } else if (size(formData.price) > 5) {
        errObj.price = "The field must not be greater than 5 characters.";
      } else if (Number(formData.price) <= 0) {
        errObj.price = "Price Amount must be greater than zero";
      } else {
        errObj.price = "";
      }

      errObj.price_unit =
        !formData.price_unit ? errorMessages.FIELD_REQUIRED : "";
    }

    if (formData.minimum_order) {
      if (size(formData.minimum_order) > 15) {
        errObj.minimum_order = "The field must not be greater than 15 characters.";
      } else if (!/^\d+(\.\d+)?$/.test(formData.minimum_order)) {
        errObj.minimum_order = errorMessages.IN_VALID_FIELD_FORMAT;
      } else if (Number(formData.minimum_order) <= 0) {
        errObj.minimum_order = "Minimum Order must be greater than zero";
      } else {
        errObj.minimum_order = "";
      }
    } else {
      errObj.minimum_order = "";
    }

    // Product description (from CKEditor → HTML string)
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = formData.product_desc;
    const trimmedText = tempDiv.textContent.trim();

    if (isEmpty(trimmedText)) {
      errObj.product_desc = errorMessages.FIELD_REQUIRED;
    } else if (trimmedText.length < 100) {
      errObj.product_desc = errorMessages.MIN_LENGTH_100_REQUIRED;
    } else if (trimmedText.length > 2000) {
      errObj.product_desc = errorMessages.MIN_LENGTH_2000_EXCEEDED;
    } else {
      errObj.product_desc = "";
    }

    errObj.trading_area =
      isEmpty(formData.trading_area) ? errorMessages.FIELD_REQUIRED : "";

    // Main image — fixed operator-precedence check
    const mainFile = formData.medias?.main?.file;
    if (!mainFile) {
      errObj.main_image = errorMessages.FIELD_REQUIRED;
    } else if (!ALLOWED_TYPES.includes(mainFile.type)) {
      errObj.main_image = "The file must be a file of type jpg, png, jpeg or pdf";
    } else if (mainFile.size > MAX_FILE_SIZE) {
      errObj.main_image = "The file must be less than or equal to 2 MB";
    } else {
      errObj.main_image = "";
    }

    // Other images (optional)
    ["img1", "img2", "img3"].forEach((key) => {
      const file = formData?.medias?.other_photos?.[key]?.file;
      if (!file) {
        errObj[key] = "";
      } else if (!ALLOWED_TYPES.includes(file.type)) {
        errObj[key] = "The file must be a file of type jpg, png, jpeg or pdf";
      } else if (file.size > MAX_FILE_SIZE) {
        errObj[key] = "The file must be less than or equal to 2 MB";
      } else {
        errObj[key] = "";
      }
    });

    // Shipping info
    if (formData.shipping_info) {
      let shippingInfoError = {};
      let shippingError = false;

      forEach(formData.shipping_info, (val, key) => {
        if (!shippingInfoError[key]) shippingInfoError[key] = {};

        const hasCountry = val.country && val.country !== "";
        const hasPorts = val.ports && !isEmpty(val.ports);

        if (size(formData.shipping_info) > 1) {
          if (!hasCountry) {
            shippingInfoError[key].country = errorMessages.FIELD_REQUIRED;
            shippingError = true;
          }
          if (hasCountry && !hasPorts) {
            shippingInfoError[key].ports = errorMessages.FIELD_REQUIRED;
            shippingError = true;
          }
        } else {
          if (hasCountry && !hasPorts) {
            shippingInfoError[key].ports = errorMessages.FIELD_REQUIRED;
            shippingError = true;
          }
        }
      });

      errObj.shipping_info = shippingError ? shippingInfoError : "";
    }

    setErrors(errObj);

    // Return true = form has errors (is invalid)
    return Object.keys(errObj).some(
      (key) => errObj[key] !== null && errObj[key] !== undefined && errObj[key] !== ""
    );
  };

  // ── Submit ────────────────────────────────────────────────────────────────

  const handleSubmit = async (e, pStatus) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);

    const hasErrors = validateForm();
    if (hasErrors) {
      setIsSubmitting(false);
      return;
    }

    // Strip portList before sending
    const updatedFormData = {
      ...formData,
      shipping_info: formData.shipping_info.map(({ portList, ...rest }) => rest),
    };

    const frmdata = new FormData();
    const data = updatedFormData;

    frmdata.append("product_name", data.product_name);
    frmdata.append("price_type", data.price_type);
    frmdata.append("price", data.price || "");
    frmdata.append("product_desc", data.product_desc);
    frmdata.append("minimum_order", data.minimum_order);

    if (isSuperAdmin || isViewer || isOpUser) {
      frmdata.append("member_id", data.member_id?.value || "");
    } else {
      frmdata.append("member_id", memberCompanyID);
    }

    frmdata.append("category", data.category?.value || "");
    frmdata.append("product_hs_code", data.product_hs_code?.value || "");
    frmdata.append("product_origin_country", data.product_origin_country?.value || "");
    frmdata.append("price_unit", data.price_unit?.value || "");

    data.trading_area.forEach((val) => frmdata.append("trading_area[]", val));
    data.shiiping_terms.forEach((val) => frmdata.append("shiiping_terms[]", val));

    data.shipping_info.forEach((info, index) => {
      frmdata.append(`shipping_info[${index}][country]`, info.country?.value || "");
      if (info.ports && info.ports.length > 0) {
        info.ports.forEach((port) =>
          frmdata.append(`shipping_info[${index}][ports][]`, port.value)
        );
      }
    });

    if (data.medias?.main?.file) {
      frmdata.append("main_image", data.medias.main.file, data.medias.main.name);
    }

    const otherPhotos = data.medias?.other_photos || {};
    Object.keys(otherPhotos).forEach((key) => {
      if (otherPhotos[key]?.file) {
        frmdata.append(`other_photos[${key}]`, otherPhotos[key].file, otherPhotos[key].name);
      }
    });

    frmdata.append('product_status', pStatus);

    try {
      const response = await props.createProduct(frmdata);

      if (response.status === true) {
        showSuccessMessage(response.message);
        setTimeout(() => {
          nav(`/${getPrefix(user)}${privateRoutePaths.MY_PRODUCTS.path}`);
        }, 3000);
      } else if (response.status === false) {
        const errorObj = { ...errors };
        const apiErr = response.error || {};

        if (apiErr.product_name) errorObj.product_name = apiErr.product_name[0];
        if (apiErr.category) errorObj.category = apiErr.category[0];
        if (apiErr.price) errorObj.price = apiErr.price[0];
        if (apiErr.price_unit) errorObj.price_unit = apiErr.price_unit[0];
        if (apiErr.product_desc) errorObj.product_desc = apiErr.product_desc[0];
        if (apiErr.product_hs_code) errorObj.hs_code = apiErr.product_hs_code[0];
        if (apiErr.product_origin_country) errorObj.product_origin_country = apiErr.product_origin_country[0];
        if (apiErr.trading_area) errorObj.trading_area = apiErr.trading_area[0];
        if (apiErr.main_image) errorObj.main_image = apiErr.main_image[0];
        if (apiErr.minimum_order) errorObj.minimum_order = apiErr.minimum_order[0];

        setErrors(errorObj);
        setIsSubmitting(false);
      }
    } catch (err) {
      console.error("createProduct error:", err);
      setIsSubmitting(false);
    }
  };

  // ── API fetch helpers ─────────────────────────────────────────────────────

  const fetchHscode = async (val) => {
    try {
      const response = await props.getHSCodeSearch(val);
      setHsCodeList(map(response, (v) => ({ label: v.code, value: v.id })));
    } catch (err) {
      console.error("getHSCodeSearch error:", err);
    }
  };

  const fetchMembers = async (val) => {
    try {
      const response = await props.getCompanyListByTradeMode("SUPPLIER", val);
      if (response.status === true) {
        setMemberList(
          map(response.data, (c) => ({
            value: c.id,
            label: c.company_list_name,
            email: c.email,
          }))
        );
      }
    } catch (err) {
      console.error("getCompanyListByTradeMode error:", err);
    }
  };

  // ── Effect: initial data load ─────────────────────────────────────────────


  const categoryList = useMemo(() => {
  if (!(isEndUser || isPreKYCUser) || !selectIndustry) return rawCategories;

  return rawCategories.map((o) =>
    selectIndustry === "Other" &&
    selectOtherIndustry &&
    o.rawLabel === "Other"
      ? { ...o, label: `Other (${selectOtherIndustry})` }
      : o
  );
}, [rawCategories, selectIndustry, selectOtherIndustry, isEndUser, isPreKYCUser]);

  useEffect(() => {
    const fetchDictionaries = async () => {
      try {
        const countryRes = await props.getCountryList();
        if (countryRes.status === true) {
          setCountryList(
            map(countryRes.data, (c) => ({
              value: c.id,
              label: c.name,
              countryCode: c.iso2,
            }))
          );
        }
      } catch (err) { console.error(err); }

      try {
        const unitRes = await props.getQuantityUnitList();
        if (!isEmpty(unitRes)) {
          setUnitList(map(unitRes, (v) => ({ label: v.unit_code, value: v.unit_code })));
        }
      } catch (err) { console.error(err); }

      try {
        const hsRes = await props.getHSCodeList();
        if (!isEmpty(hsRes)) {
          const opts = map(hsRes, (v) => ({ label: v.code, value: v.id }));
          allHsCodesRef.current = opts;
          setHsCodeList(opts);
        }
      } catch (err) { console.error(err); }

      try {
        // const catRes = await props.getCategories();
        // if (!isEmpty(catRes)) {
        //   setCategoryList(map(catRes, (v) => ({ label: v.category_name, value: v.id })));
        // }

        const catRes = await props.getCategories();
              if (!isEmpty(catRes)) {
               setRawCategories(
                  map(catRes, (v) => ({
                    label: v.category_name,
                    rawLabel: v.category_name,
                    value: v.id,
                  }))
                );

              }

      } catch (err) { console.error(err); }

      try {
        const memberRes = await props.getCompanyListByTradeMode("SUPPLIER", "");
        if (memberRes.status === true) {
          setMemberList(
            map(memberRes.data, (c) => ({
              value: c.id,
              label: c.company_list_name,
              email: c.email,
            }))
          );
        }
      } catch (err) { console.error(err); }
    };

    fetchDictionaries();
  }, []);

  const getProductList = async (ofst, lmt, member = 0, pStatus = "") => {
    let reqData = {
      offset: ofst,
      limit: lmt,
      member: member,
      product_status: pStatus
    }
    await props.fetchProducts(reqData).then((response) => {
      if (response.status === true) {
        setProducts(response.data);
        const step1 = response?.data[0]?.category?.category_name;
        setSelectIndustry(step1);
        setSelectOtherIndustry(response?.data[0]?.company?.member_industry?.industy_name);
      }
    }).catch((err) => {
      console.log("Error ============ ", err);
    })
  }

   useEffect(() => {
      getProductList(offset, limit, 0, "");
    }, []);


//  useEffect(() => {
//     if (!selectIndustry || categoryList.length === 0) return;

//     if(isEndUser || isPreKYCUser) {
//         const selected = categoryList.find(
//         (o) => String(o.label) === String(selectIndustry) || String(o.label) === 'Other'
//       );
//       if (!selected) return;

//       setFormData((prev) => {
//         if (String(prev.category?.value ?? prev.category) === String(selected.value) || String(prev.category) === 'Other') {
//           return prev;
//         }
//         return { ...prev, category: selected };
//       });
//     }
   
//   }, [categoryList, selectIndustry, isEndUser, isPreKYCUser]);
useEffect(() => {
  if (!selectIndustry || categoryList.length === 0) return;
  if (!(isEndUser || isPreKYCUser)) return;

  const selected = categoryList.find(
    (o) => String(o.rawLabel) === String(selectIndustry)
  );
  if (!selected) return;

  setFormData((prev) =>
    String(prev.category?.value ?? prev.category) === String(selected.value)
      ? prev
      : { ...prev, category: selected }
  );
}, [categoryList, selectIndustry, isEndUser, isPreKYCUser]);
    
      const getCategoryOption = (cat) => {
        if (cat === undefined || cat === null || cat === '') return null;
        const key = typeof cat === 'object' ? cat.value ?? cat.id : cat;
        return (
          categoryList.find(
            (o) =>
              String(o.value) === String(key) ||
              String(o.label) === String(key)
          ) || null
        );
      };

    console.log("isEndUser ===========",isEndUser);
  

  console.log("-----------selectIndustry-------------",selectOtherIndustry);

  // ── Render ────────────────────────────────────────────────────────────────

  return (
    <div className="data-table-main">
      <SubHeader
        layer1="My Products"
        layer2="List"
        layer3="Add"
        pageName="Add Product"
        subTitle=""
        clickable={{ layer1: "", layer2: "", layer3: "" }}
      />

      {/* <form onSubmit={handleSubmit} className="bg-white shadow rounded p-4 mb-4"> */}
      <div className="bg-white shadow rounded p-4 mb-4">

        {/* ── Basic Details ── */}
        <div className="pb-3 border-bottom">
          <h4 className="head-office-text">Product Basic Details</h4>
        </div>

        {(isSuperAdmin || isViewer || isOpUser) && (
          <div className="row pt-3">
            <div className="col-xl-4">
              <label className="profile-text">
                Company Name<span className="text-danger"> *</span>
              </label>
              <div className="d-flex">
                <div className="w-100">
                  <ReactSelect
                    options={memberList}
                    onInputChange={handleMemberInputChange}
                    labelledBy="Select"
                    name="member_id"
                    value={formData.member_id}
                    classNamePrefix="react-select"
                    onChange={(e) => handleSelectChange(e, "member_id")}
                    noOptionsMessage={() => "No Company Found"}
                    filterOption={customMemberFilter}
                  />
                  {errors.member_id && (
                    <span className="invalid-feedback" style={{ display: "block" }}>
                      {errors.member_id}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        <div className={(isSuperAdmin || isViewer || isOpUser) ? "row" : "row pt-3"}>

          {/* Product Name */}
          <div className="col-xl-4 py-2">
            <label className="profile-text">
              Product Name<span className="text-danger"> *</span>
            </label>
            <div className="d-flex">
              <div className="w-100">
                <InputField
                  placeholder="Enter your product name"
                  className="input-error-border mr-input"
                  autoComplete="off"
                  value={formData.product_name}
                  name="product_name"
                  onChange={handleInputChange}
                  onBlur={handleFocusOut}
                />
                {errors.product_name && (
                  <span className="invalid-feedback" style={{ display: "block" }}>
                    {errors.product_name}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Category */}
          <div className="col-xl-4 py-2">
            <label className="profile-text">
              Product Category<span className="text-danger"> *</span>
            </label>
            <DropDown
              className="input-error-border"
              name="category"
              options={categoryList}
              // value={formData.category}
              value={getCategoryOption(formData.category)}
              onChange={(e) => handleSelectChange(e, "category")}
              isDisabled={isEndUser || isPreKYCUser}
            />
            {errors.category && (
              <span className="invalid-feedback" style={{ display: "block" }}>
                {errors.category}
              </span>
            )}
          </div>

          {/* HS Code */}
          <div className="col-xl-4 py-2">
            <label className="profile-text">
              Product HSN Code<span className="text-danger"> *</span>
            </label>
            <ReactSelect
              options={hscodeList}
              onInputChange={handlehscodeInputChange}
              labelledBy="Select"
              name="product_hs_code"
              value={formData.product_hs_code}
              classNamePrefix="react-select"
              onChange={(e) => handleSelectChange(e, "hs_code")}
              noOptionsMessage={() => "No Hs Code Found"}
              filterOption={customFilter}
            />
            {errors.hs_code && (
              <span className="invalid-feedback" style={{ display: "block" }}>
                {errors.hs_code}
              </span>
            )}
          </div>

          {/* Origin Country */}
          <div className="col-xl-4 py-2">
            <label className="profile-text">
              Product Origin Country<span className="text-danger"> *</span>
            </label>
            <DropDown
              className="input-error-border"
              name="country"
              options={countryList}
              value={formData.product_origin_country}
              onChange={(e) => handleSelectChange(e, "origin_country")}
            />
            {errors.product_origin_country && (
              <span className="invalid-feedback" style={{ display: "block" }}>
                {errors.product_origin_country}
              </span>
            )}
          </div>

          {/* Price Type */}
          <div className="col-xl-4 py-2">
            <label className="profile-text">
              Price Type <span className="text-danger">*</span>
            </label>
            <div className="d-flex">
              <div className="d-inline">
                <RadioButtonField
                  name="priceSelection"
                  value="fixed"
                  checked={formData.price_type === "fixed"}
                  onChange={handlePriceTypeChange}
                />
                <label>Fixed</label>
              </div>
              <div className="d-inline">
                <RadioButtonField
                  name="priceSelection"
                  value="requestQuote"
                  checked={formData.price_type === "requestQuote"}
                  onChange={handlePriceTypeChange}
                />
                <label>Request on Quote</label>
              </div>
            </div>
          </div>

          {/* Price Amount */}
          {formData.price_type === "fixed" && (
            <div className="col-xl-2 py-2">
              <label className="profile-text">
                Price Amount<span className="text-danger"> *</span>
              </label>
              <div className="w-100">
                <InputField
                  placeholder="Enter Your Product Price"
                  className="input-error-border mr-input"
                  value={formData.price}
                  onChange={handleInputChange}
                  onBlur={handleFocusOut}
                  name="price"
                />
                {errors.price && (
                  <span className="invalid-feedback" style={{ display: "block" }}>
                    {errors.price}
                  </span>
                )}
              </div>
            </div>
          )}

          {/* Price Unit */}
          {formData.price_type === "fixed" && (
            <div className="col-xl-2 py-2">
              <label className="profile-text">
                Product Unit<span className="text-danger"> *</span>
              </label>
              <DropDown
                className="input-error-border"
                name="product_unit"
                options={unitList}
                onChange={(e) => handleSelectChange(e, "price_unit")}
                value={formData.price_unit}
              />
              {errors.price_unit && (
                <span className="invalid-feedback" style={{ display: "block" }}>
                  {errors.price_unit}
                </span>
              )}
            </div>
          )}

          {/* Product Description */}
          <div className="col-xl-12 py-2">
            <label className="profile-text">
              Product Description <span className="text-danger"> *</span>
            </label>
            <div className="input-wrape">
              <div className="input-pad inquiry-ck-editer">
                <div className={`ck-editor-wrapper ${errors.product_desc ? "ck-error" : ""}`}>
                  <CKEditor
                    editor={ClassicEditor}
                    config={{
                      toolbar: {
                        items: ["bold", "italic", "underline", "fontSize", "bulletedList"],
                      },
                      fontSize: {
                        options: [10, 12, 14, "default", 18, 20, 22, 24, 30],
                        supportAllValues: false,
                      },
                      language: "en",
                      plugins: [Essentials, Bold, Italic, Underline, FontSize, Paragraph, List],
                      licenseKey: "GPL",
                    }}
                    onChange={(event, editor) => {
                      setFormData((prev) => ({
                        ...prev,
                        product_desc: editor.getData(),
                      }));
                    }}
                    onBlur={(event, editor) => {
                      const tempDiv = document.createElement("div");
                      tempDiv.innerHTML = editor.getData();
                      const trimmedText = tempDiv.textContent.trim();

                      setErrors((prev) => {
                        const er = { ...prev };
                        if (isEmpty(trimmedText)) {
                          er.product_desc = errorMessages.FIELD_REQUIRED;
                        } else if (trimmedText.length < 100) {
                          er.product_desc = errorMessages.MIN_LENGTH_100_REQUIRED;
                        } else if (trimmedText.length > 2000) {
                          er.product_desc = errorMessages.MIN_LENGTH_2000_EXCEEDED;
                        } else {
                          er.product_desc = "";
                        }
                        return er;
                      });
                    }}
                    onReady={(editor) => {
                      editor.editing.view.change((writer) => {
                        writer.setStyle(
                          "height", "150px",
                          editor.editing.view.document.getRoot()
                        );
                        writer.setStyle(
                          "width", "100%",
                          editor.editing.view.document.getRoot()
                        );
                      });
                    }}
                  />
                </div>
                {errors.product_desc && (
                  <span className="invalid-feedback" style={{ display: "block" }}>
                    {errors.product_desc}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* ── Product Medias ── */}
        <div className="product-media-wrape mb-4">
          <div className="py-3 mb-2 border-bottom">
            <h4 className="head-office-text">Product Medias</h4>
          </div>

          <div className="row py-2">
            {/* Main Image */}
            <div className="col-xxl-3 col-xl-3 col-md-3">
              <div className="d-flex">
                <div className="w-100">
                  <p className="mb-1">
                    <b>Main Image <span className="text-danger"> *</span></b>
                  </p>
                  <div className="img-wrape main-img">
                    <input
                      type="file"
                      ref={mainImgRef}
                      autoComplete="off"
                      accept="image/*"
                      onChange={(e) => handleFileChange(e, "main")}
                    />
                    <img
                      src={formData.medias.main?.path || ImgUpload}
                      alt="main-product-image"
                      onClick={(e) => handleImgClick(e, "main")}
                    />
                    {formData.medias.main?.path && (
                      <div onClick={(e) => removeImage(e, "main")} className="delete-icon">
                        <i className="fa-regular fa-trash-can text-danger"></i>
                      </div>
                    )}
                  </div>
                  {errors.main_image && (
                    <span className="invalid-feedback" style={{ display: "block" }}>
                      {errors.main_image}
                    </span>
                  )}
                </div>
              </div>
            </div>

            {/* Other Images */}
            <div className="col-xxl-9 col-xl-9 col-lg-12 other-img-wrape">
              <div className="row">
                <div className="col-xxl-12">
                  <p className="mb-1"><b>Other Images</b></p>
                </div>

                {["img1", "img2", "img3"].map((imgKey, i) => {
                  const refMap = { img1: fileInputRef1, img2: fileInputRef2, img3: fileInputRef3 };
                  const imgPath = formData.medias?.other_photos?.[imgKey]?.path;

                  return (
                    <div key={imgKey} className="col-xxl-4 col-xl-4 col-md-6">
                      <div className="d-flex">
                        <div className="w-100">
                          <div className="img-wrape">
                            <input
                              type="file"
                              ref={refMap[imgKey]}
                              autoComplete="off"
                              accept="image/*"
                              onChange={(e) => handleFileChange(e, imgKey)}
                            />
                            <img
                              src={imgPath || ImgUpload}
                              alt={`product-image-${i + 1}`}
                              onClick={(e) => handleImgClick(e, imgKey)}
                            />
                            {imgPath && (
                              <div onClick={(e) => removeImage(e, imgKey)} className="delete-icon">
                                <i className="fa-regular fa-trash-can text-danger"></i>
                              </div>
                            )}
                          </div>
                          {errors[imgKey] && (
                            <span className="invalid-feedback" style={{ display: "block" }}>
                              {errors[imgKey]}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        {/* ── Shipping Details ── */}
        <div className="py-3 border-bottom">
          <h4 className="head-office-text">Product Shipping Details</h4>
        </div>

        <div className="row">
          {/* Trading Area */}
          <div className="col-xl-4 py-2">
            <label className="profile-text">
              Trading Area <span className="text-danger"> *</span>
            </label>
            <div className="d-flex mt-2">
              {["domestic", "international"].map((area) => (
                <div key={area} className="d-flex">
                  <div className="d-inline">
                    <CheckBox
                      onChange={(e) => handleCheckChange(e, area)}
                      name="trading_area"
                      label={area.charAt(0).toUpperCase() + area.slice(1)}
                    />
                  </div>
                  <label>{area.charAt(0).toUpperCase() + area.slice(1)}</label>
                </div>
              ))}
            </div>
            {errors.trading_area && (
              <span className="invalid-feedback" style={{ display: "block" }}>
                {errors.trading_area}
              </span>
            )}
          </div>

          {/* Shipping Type */}
          <div className="col-xl-4 py-2">
            <label className="profile-text">Shipping Type</label>
            <div className="d-flex mt-2">
              {shippingTerms.map((term) => (
                <div key={term} className="d-flex">
                  <div className="d-inline">
                    <CheckBox
                      onChange={(e) => handleCheckChange(e, term)}
                      label={term}
                      name="shipping_type"
                    />
                  </div>
                  <label>{term}</label>
                </div>
              ))}
            </div>
          </div>

          {/* Minimum Order */}
          <div className="col-xl-4 py-2">
            <label className="profile-text">Minimum Order</label>
            <div className="w-100">
              <InputField
                placeholder="Enter Your Minimum Order"
                className="input-error-border mr-input"
                value={formData.minimum_order || ""}
                onChange={handleInputChange}
                onBlur={handleFocusOut}
                name="minimum_order"
              />
              {errors.minimum_order && (
                <span className="invalid-feedback" style={{ display: "block" }}>
                  {errors.minimum_order}
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Port rows */}
        <div className="row">
          {map(formData.shipping_info, (sInfo, indx) => (
            <React.Fragment key={indx}>
              <div className="col-xl-4 py-3">
                <label className="profile-text">Port Of Country</label>
                <DropDown
                  className="input-error-border"
                  name="port_of_country"
                  options={countryList}
                  isMulti={false}
                  value={formData.shipping_info[indx].country || null}
                  onChange={(e) => handleCountryChange(e, indx)}
                  isClearable={true}
                />
                {errors.shipping_info?.[indx]?.country && (
                  <span className="invalid-feedback" style={{ display: "block" }}>
                    {errors.shipping_info[indx].country}
                  </span>
                )}
              </div>

              <div className="col-xl-4 py-3">
                <label className="profile-text">Port Of Shipping</label>
                <DropDown
                  className="input-error-border"
                  name="shipping_port"
                  options={formData.shipping_info[indx].portList || []}
                  isMulti={true}
                  value={formData.shipping_info[indx].ports || []}
                  onChange={(e) => handlePortChange(e, indx)}
                />
                {errors.shipping_info?.[indx]?.ports && (
                  <span className="invalid-feedback" style={{ display: "block" }}>
                    {errors.shipping_info[indx].ports}
                  </span>
                )}
              </div>

              <div className="col-xl-4 py-3">
                <div className="d-flex" style={{ marginTop: "30px" }}>
                  <button type="button" onClick={handleAddClick} className="btn outlines">
                    <i className="fa fa-plus"></i>
                  </button>
                  <button
                    type="button"
                    onClick={(e) => handleRemoveClick(e, indx)}
                    className="btn outlines"
                  >
                    <i className="fa fa-minus"></i>
                  </button>
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>

        {/* Submit */}
        <div className="col-xxl-12 text-end border-top mt-5">
          {
            (isSuperAdmin || isViewer || isOpUser) ? <ButtonAdminpanel className="mt-3 mx-3" type="button" disabled={isSubmitting} onClick={(e) => handleSubmit(e, 2)}>
              Save product
            </ButtonAdminpanel> : <ButtonAdminpanel className="mt-3 mx-3" type="button" disabled={isSubmitting} onClick={(e) => handleSubmit(e, 0)}>
              Save As Draft
            </ButtonAdminpanel>
          }

          {
            (isPreKYCUser || isEndUser) && <ButtonAdminpanel className="mt-3" type={"button"} disabled={isSubmitting} onClick={(e) => handleSubmit(e, 2)}>Send For Approval</ButtonAdminpanel>
          }


        </div>

        {/* </form> */}
      </div>
      {/* <ToastContainer /> */}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchProducts: (reqData) => dispatch(productList(reqData)),
    getCountryList: () => dispatch(countryList()),
    getQuantityUnitList: () => dispatch(getQuantityUnitList()),
    getHSCodeList: () => dispatch(getHSCodeList()),
    getHSCodeSearch: (search_txt) => dispatch(getHSCodeSearchList(search_txt)),
    getCategories: () => dispatch(getCategories()),
    getPortsByCountry: (country_id) => dispatch(getPortsByCountry(country_id)),
    createProduct: (data) => dispatch(createProduct(data)),
    getCompanyListByTradeMode: (trade_mode, searchTxt) => dispatch(getCompanyListByTradeMode(trade_mode, searchTxt)),
    // getSupplier: (supplier_id) => dispatch(getSupplierMember(supplier_id)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
